const INTERACTIVE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'details',
  'summary',
  '[tabindex]:not([tabindex="-1"])',
  '[contenteditable="true"]',
  '[role="button"]',
  '[role="link"]',
  '[role="menuitem"]',
  '[role="tab"]',
  '[role="option"]',
  '[role="gridcell"]',
  '[role="columnheader"]',
  '[role="rowheader"]'
];

// Store observers for cleanup
/** @type {MutationObserver[]} */
let observers = [];

function updateElementFocusability() {
  const interactiveElements = document.querySelectorAll(INTERACTIVE_SELECTORS.join(','));
  
  interactiveElements.forEach(element => {
    const slideshowSlide = element.closest('slideshow-slide');
    if (slideshowSlide && slideshowSlide.getAttribute('aria-hidden') === 'true') {
      if (!element.hasAttribute('data-original-tabindex')) {
        const currentTabindex = element.getAttribute('tabindex');
        element.setAttribute('data-original-tabindex', currentTabindex || '0');
      }
      element.setAttribute('tabindex', '-1');
      element.setAttribute('aria-hidden', 'true');
    } else {
      if (element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('data-original-tabindex');
        if (originalTabindex === '0') {
          element.removeAttribute('tabindex');
        } else if (originalTabindex) {
          element.setAttribute('tabindex', originalTabindex);
        }
        element.removeAttribute('data-original-tabindex');
      }
      element.removeAttribute('aria-hidden');
    }
  });
}

function disconnectObservers() {
  observers.forEach(observer => {
    if (observer && typeof observer.disconnect === 'function') {
      observer.disconnect();
    }
  });
  observers = [];
}

function initializeADACompliance() {
  // Clean up any existing observers
  disconnectObservers();
  
  updateElementFocusability();
  
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'aria-hidden' &&
          mutation.target instanceof Element &&
          mutation.target.tagName === 'SLIDESHOW-SLIDE') {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      requestAnimationFrame(updateElementFocusability);
    }
  });
  
  const slideshowSlides = document.querySelectorAll('slideshow-slide');
  slideshowSlides.forEach(slide => {
    observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  });
  
  const slideshowObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE && node instanceof Element) {
          if (node.tagName === 'SLIDESHOW-SLIDE') {
            observer.observe(node, { attributes: true, attributeFilter: ['aria-hidden'] });
            requestAnimationFrame(updateElementFocusability);
          } else {
            const slides = node.querySelectorAll('slideshow-slide');
            if (slides && slides.length > 0) {
              slides.forEach(function(slide) {
                observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
              });
              requestAnimationFrame(updateElementFocusability);
            }
          }
        }
      });
    });
  });
  
  const slideshowContainers = document.querySelectorAll('slideshow-component, slideshow, [class*="slideshow"]');
  slideshowContainers.forEach(container => {
    slideshowObserver.observe(container, { childList: true, subtree: true });
  });
  
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE && node instanceof Element) {
          if (node.tagName === 'SLIDESHOW-SLIDE') {
            observer.observe(node, { attributes: true, attributeFilter: ['aria-hidden'] });
            requestAnimationFrame(updateElementFocusability);
          } else {
            const slides = node.querySelectorAll('slideshow-slide');
            if (slides && slides.length > 0) {
              slides.forEach(function(slide) {
                observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
              });
              requestAnimationFrame(updateElementFocusability);
            }
          }
        }
      });
    });
  });
  
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  
  // Store observers for cleanup
  observers.push(observer, slideshowObserver, bodyObserver);
}

// Cleanup function for page transitions
function cleanupADACompliance() {
  disconnectObservers();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeADACompliance);
} else {
  initializeADACompliance();
}

document.addEventListener('page:loaded', initializeADACompliance);

document.addEventListener('section:loaded', function(event) {
  if (event.target && event.target instanceof Element && event.target.querySelector('slideshow-slide')) {
    requestAnimationFrame(updateElementFocusability);
  }
});

// Clean up observers on page unload
window.addEventListener('beforeunload', cleanupADACompliance);

// Clean up observers on page hide (for SPA navigation)
document.addEventListener('page:hide', cleanupADACompliance); 